package at.apa.statistictracker.util

import at.apa.statistictracker.data.model.Platform

actual fun getPlatform() = Platform.WEB